export default [
    {
      path: '/eat',
      name: 'eat-read',
      component: () => import('@/views/event/eat/EatList.vue'),
      meta: {
        resource: 'Eat',
        action: 'read',
      },
    },
    {
        path: '/eat-icon',
        name: 'eat-icon-read',
        component: () => import('@/views/event/eat/EatIconList.vue'),
        meta: {
          resource: 'Eat Icons',
          action: 'read',
        },
    },
  ]